import React from 'react';
import css from './index.module.scss'
import $ from "jquery";



export default () => {


    const showAnswer = e => {
      $(e.currentTarget).find(`.${css.answer}`).slideToggle()
      $(e.currentTarget).find('i').toggleClass(css.rotate)
      $(e.currentTarget).toggleClass(css.liUpdater)
    }

    return(
    <section className = {css.section}>
       <h2>Frequently Asked Questions</h2>
       <ul>
           <li onClick = {e => showAnswer(e)}>
               <p>
                   How can i get help by the cloud weather app?
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
           <li onClick = {e => showAnswer(e)} >
               <p>
               User Guide ; Getting started
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
           <li onClick = {e => showAnswer(e)} >
               <p>
               How can i get help by weather services agency?
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
           <li onClick = {e => showAnswer(e)} >
               <p>
               Are you plan to open a branch in New York?
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
           <li onClick = {e => showAnswer(e)} >
               <p>
               How long your contract term?
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
           <li onClick = {e => showAnswer(e)} >
               <p>
               What about loan programs and after bank advantage?
               </p>
               <p className = {css.answer}>
               Digital Marketing Agency all foundational tool need inbound success. With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day. Digital Marketing Agency all foundational too inbound success.With module there no to go another day.
               </p>
               <i className="fa fa-chevron-down"></i>
           </li>
       </ul>
    </section>
)}